import { useQuery } from '@tanstack/react-query';
import {
  listMyTasksContract,
  type ListMyTasksResponse,
  type TaskListItem
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { taskKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';

export type { TaskListItem };

/**
 * The caller's open Aufgaben — tasks handed to them by a manager or an app,
 * as distinct from the process work `useTasks` aggregates. Shared by the
 * customer "Meine Aufgaben" page, the partner "Aufgaben" page and both
 * sidebars' badges, and refreshed on the same events as `useTasks`.
 */
export function useMyOpenTasks() {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: taskKeys.mine,
    queryFn: async ({ signal }): Promise<TaskListItem[]> => {
      const { data } = await apiClient.get<ListMyTasksResponse>(listMyTasksContract.path, {
        signal
      });
      return data.tasks;
    },
    enabled: !!token,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchInterval: 120000,
    refetchIntervalInBackground: false
  });
}
